import { useEffect, useState, type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// App keys this boundary by account: no cache is shared between identities.
export function JournalQueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          // Preserve explicit failure/retry; do not silently queue writes offline.
          queries: {
            networkMode: "always",
            retry: false,
            staleTime: 30_000,
            refetchOnWindowFocus: false,
          },
          mutations: { networkMode: "always", retry: false },
        },
      })
  );
  useEffect(
    () => () => {
      void client.cancelQueries();
      client.clear();
    },
    [client]
  );
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}

export const journalKey = (apiBase: string, userId: string) => [apiBase, userId, "entries"];
export const visitsKey = (apiBase: string, userId: string) => [apiBase, userId, "visits"];
